<template>
    <div class="input-box">
        <label>{{name}} <span v-if="required">*</span></label>
        <span class="password-icon" v-if="type == 'password' || type == 'password_confirm' ">
            <font-awesome-icon @click="handleShowPassword" v-if="!showPassword" :icon="['fa', 'eye-slash']" />
            <font-awesome-icon @click="handleShowPassword" v-if="showPassword" :icon="['fa', 'eye']" />
        </span>
        <input 
            :type="setType()" 
            :name="id"
            :id="id"
            v-model="content"
            @input="handleInput"
            @blur="validate()"
            @keyup="clearErrors()"
            />
        <span class="error" v-if="errorMessage">{{errorMessage}}</span>
    </div>
</template>

<script>

    const types = {
        email: {
            regex: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
            message: 'O E-mail digitado é inválido.',
        },
        password: {
            regex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/,
            message: 'A Senha digitada não é forte. Digite pelo menos um número, uma letra maiúscula, uma letra minúscula e um caracter especial.',
        },
        number: {
            regex: /^\d+$/,
            message: 'Utilize apenas números.',
        },
        cpf: {
            regex: '',
            mask: '###.###.###-##',
            message: 'O CPF digitado é inválido.'
        }
    }

    export default {
        name: "input-text",
        model: {
            prop: 'value',
            event: 'input'
        },
        data() {
            return {
                id: null,
                name: null,
                type: null,
                content: this.value,
                required: false,
                regexValidate: true,
                errorMessage: null,
                showPassword: false,
            }
        },
        methods: {
            setType() {
                if(this.type == 'password' || this.type == 'password_confirm')
                    return 'password';
                return 'text';
            },
            handleShowPassword() {
                this.showPassword = !this.showPassword;
                const password = document.getElementById(this.id);
                if(this.showPassword){
                    password.type = "text";
                }else{
                    password.type = "password";
                }
            },
            handleInput (e) {
                this.$emit('input', this.content)
            },
            validate() {
                if(this.required && (this.content == '' || this.content == null) ) {
                    this.errorMessage = `O campo ${this.name} é obrigatório`;
                }else if(this.regexValidate && types[this.type] && !types[this.type].regex.test(this.content)){
                    this.errorMessage = types[this.type].message;
                }else{
                    this.clearErrors();
                }
            },
            clearErrors() {
                this.errorMessage = null;
            }
        },
        mounted() {
            this.id = (this.$attrs.inId) ? this.$attrs.inId : null;
            this.name = (this.$attrs.inName) ? this.$attrs.inName : null;
            this.type = (this.$attrs.inType) ? this.$attrs.inType : 'text';
            this.required = (this.$attrs.inRequired) ? this.$attrs.inRequired : false;
            if(this.$attrs.noValidation) this.regexValidate = false;
        }
    }
</script>

<style scoped>
    @import "./input.scss";
</style>


// WEBPACK FOOTER //
// src/components/Input/InputText.vue